// extracted by mini-css-extract-plugin
module.exports = {"header":"YqA7J6","usingExtendedGridGalleryStyles":"gwd0Lt","title":"ptBG4I","cancel":"uIETfi"};